export default __webpack_public_path__ + "static/StandardCrypto-e767f261abe9a973723e9c69e6dcc8e9.png";